import { type FC } from 'react';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { type BaseProps } from 'src/modules/shared/types/component.type';
import { Panel } from 'src/modules/shared/components/molecules/panel';

interface DraggableBoardColumnProps extends BaseProps {
  /** Optional background treatment for the full column body. */
  bodyClassName?: string;
  items: string[];
  header?: React.ReactNode;
  isHighlighted?: boolean;
  setRefs?: (node: HTMLDivElement | null) => void;
}

export const DraggableBoardColumn: FC<DraggableBoardColumnProps> = ({
  children,
  className = '',
  bodyClassName = '',
  items,
  header,
  isHighlighted,
  setRefs,
}) => {
  return (
    <div
      className={`flex-none w-[280px] h-full min-h-0 mx-2 pb-2 flex flex-col ${className}`}
    >
      <Panel
        className={`flex flex-col flex-1 min-h-0 rounded-xl ${bodyClassName}`}
        shadow="sm"
        isActive={isHighlighted}
      >
        {header && (
          <div className="shrink-0 border-b-2 border-white/80">{header}</div>
        )}
        <div className="flex flex-col flex-1 min-h-0 pt-2 pb-4">
          <div
            ref={setRefs}
            className="flex-1 min-h-0 overflow-y-auto overflow-x-hidden px-1"
          >
            <SortableContext
              items={items}
              strategy={verticalListSortingStrategy}
            >
              <div className="flex flex-col h-full space-y-4 p-2 py-0">
                {children}
              </div>
            </SortableContext>
          </div>
        </div>
      </Panel>
    </div>
  );
};
